import styled from 'styled-components';
import { Typography } from '../../../../../../stories/atoms';
import { RowFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';

export const MetricItemsContainer = styled(RowFlexContainer)`
  flex: 1;
  background-color: ${({ theme: { palette, color } }) =>
    palette.mode === 'dark' ? color.backgroundPaperDark : color.backgroundTableHeader};
  border-style: solid;
  border-color: ${({ theme: { palette, color } }) =>
    palette.mode === 'dark' ? color.borderGrayDark : color.borderGray};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
`;

export const StyledValueTypography = styled(Typography)`
  line-height: inherit;
`;

export const MetricItemWrapper = styled(RowFlexContainer)`
  &:first-child {
    border-right-style: solid;
    border-right-width: 1px;
    border-right-color: ${({ theme: { color } }) => color.borderGray};
  }
`;
